<script lang="ts">
  import { Route } from "svelte-router-spa";
  import { onMount } from "svelte";
  import { Button, Container, Input } from "sveltestrap";

  import Cookies from "js-cookie";

  import Spacer from "@/components/spacer.svelte";
  import Editor from "@/components/editor.svelte";

  import documentapi from "@/functions/api/documentapi";
  import type { IBoard, IDocument } from "@/types";

  export let currentRoute;

  let isauth = Cookies.get("auth");

  let mode: "view" | "edit" = "view";
  let boardlist: IBoard[];
  let currentboard: IBoard;
  let document: IDocument | undefined;
  let promise;
  let data = "";
  let data_origin = "";
  let title = "";
  let title_origin = "";

  onMount(async () => {
    promise = documentapi.get(currentRoute.namedParams.id as string);
    const x = await promise;

    document = x.document;
    boardlist = x.boardList;
    currentboard = boardlist.find((x) => x.code == document.code);
    data = document.contents;
    title = document.title;
  });

  const ev수정하기클릭 = () => {
    mode = "edit";
    data_origin = data;
    title_origin = title;
  };

  const ev수정취소클릭 = () => {
    mode = "view";
    data = data_origin;
    title = title_origin;
  };

  const ev수정완료클릭 = async () => {
    try {
      await documentapi.update(document.sk, title, data);
      location.reload();
    } catch (e) {
      alert("오류가 있어서 글 수정이 안되었습니다");
    }
  };

  const ev삭제하기클릭 = async () => {
    try {
      const r = confirm("삭제하시겠습니까?");
      if (r == true) {
        await documentapi.drop(document.sk);
        location.href = `/board/list/${currentboard.code}`;
      }
    } catch (e) {
      alert("삭제 실패");
    }
  };
  const m1 = ["news", "video", "press"];
</script>

<Spacer size="10rem" />

<Container>
  {#await promise then _x}
    {@const d = document}

    <h1>{currentboard?.name}</h1>
    <div class="mb-5" />

    {#if mode == "view"}
      <h3>
        {title}
      </h3>
      <hr />

      {@html d?.contents + "<style>p {margin-bottom: 0.05rem !important;}</style>"}

      <a href="/board/list/{d?.code}" class="btn btn-outline-dark">목록으로</a>
      {#if isauth == "true"}
        <Button on:click={ev수정하기클릭}>수정하기</Button>
        <Button on:click={ev삭제하기클릭} color="danger">삭제하기</Button>
      {/if}
    {/if}
    {#if d?.code.indexOf('pf') != -1}
    <script>
      setTimeout(function(){
        var elem = document.getElementsByClassName("menu-title");
        for (var i = 0; i < elem.length; i++) {
        elem[i].getElementsByClassName("nav-a")[0].style.color =
          "rgba(0,0,0,0.84)";
      }
      elem[2].getElementsByClassName("nav-a")[0].style.color = "#a11f1f";
      },1000);
    </script>
    {:else if m1.includes(d?.code)}
      <script>
        setTimeout(function(){
          var elem = document.getElementsByClassName("menu-title");
          for (var i = 0; i < elem.length; i++) {
          elem[i].getElementsByClassName("nav-a")[0].style.color =
            "rgba(0,0,0,0.84)";
        }
        elem[3].getElementsByClassName("nav-a")[0].style.color = "#a11f1f";
        },1000);
      </script>
    {:else}
      <script>
        setTimeout(function(){
          var elem = document.getElementsByClassName("menu-title");
          for (var i = 0; i < elem.length; i++) {
          elem[i].getElementsByClassName("nav-a")[0].style.color =
            "rgba(0,0,0,0.84)";
        }
        elem[4].getElementsByClassName("nav-a")[0].style.color = "#a11f1f";
        },1000);
    </script>
    {/if}
    

    {#if mode == "edit" && isauth == "true"}
      <div>
        <Input bind:value={title} />
        <Spacer size="1rem" />

        <Editor bind:data />

        <Spacer size="1rem" />
        <Button color="success" on:click={ev수정완료클릭}>수정완료</Button>
        <Button outline on:click={ev수정취소클릭}>수정취소</Button>
      </div>
    {/if}
  {:catch}
    <h3>없는 게시물 입니다</h3>
  {/await}
</Container>
<Spacer size="10rem" />

<Route {currentRoute} />
